// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'dev',
  apiUrl: 'https://tm.stage.cts-connect.com/WebAPI/',
  appBuild: '21563',
  application: 'Telemarketing',
  cacheBreak: true,
  environment: 'PROD',
  pod: '1',
  sessionID: 'fdaa82d7-11da-4c98-b741-4a7267b15ba1',
  trapErrors: true,
  templateS3Bucket: 'onvida-common/templates',
  loginUrl: 'https://tm.stage.cts-connect.com/Angular/',
  //apiUrl: 'https://tm.q-central.com/'
  PCHImageNetUrl: 'https://parkland-demo.imagenetllc.net/Data/Browse/View',
  enableKBChatbot: true,
  showInternetSpeed: true,
  enableEmailQueue: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
